<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0">

    <!-- ── IMPORT RESULTS ── -->
    <div class="table-responsive2" *ngIf="isImported">

        <!-- Summary Cards -->
        <div class="summary-cards">
            <div class="summary-card total">
                <span class="summary-count">{{ summaryStats.totalProcessed }}</span>
                <span class="summary-label">Total</span>
            </div>
            <div class="summary-card success">
                <span class="summary-count">{{ summaryStats.totalSuccess }}</span>
                <span class="summary-label">Inserted</span>
            </div>
            <div class="summary-card skipped">
                <span class="summary-count">{{ summaryStats.totalSkipped }}</span>
                <span class="summary-label">Skipped</span>
            </div>
            <div class="summary-card failed">
                <span class="summary-count">{{ summaryStats.totalFailed }}</span>
                <span class="summary-label">Failed</span>
            </div>
        </div>

        <!-- Tab Toggle -->
        <div class="result-tabs" *ngIf="allResults.length">
            <button class="tab-btn" [class.active]="activeTab === 'all'" (click)="switchTab('all')">All</button>
            <button class="tab-btn" [class.active]="activeTab === 'success'"
                (click)="switchTab('success')">Inserted</button>
            <button class="tab-btn" [class.active]="activeTab === 'skipped'"
                (click)="switchTab('skipped')">Skipped</button>
            <button class="tab-btn" [class.active]="activeTab === 'failed'"
                (click)="switchTab('failed')">Failed</button>
        </div>

        <table mat-table [dataSource]="dataSource1" matSort class="mat-elevation-z8 result-table">
            <ng-container matColumnDef="employeeId">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>ID</th>
                <td mat-cell *matCellDef="let element">{{ element.employeeId }}</td>
            </ng-container>

            <ng-container matColumnDef="employeeName">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.employeeName }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge" [ngClass]="{
                            'status-success': element.status === 'success',
                            'status-failed':  element.status === 'failed',
                            'status-skipped': element.status === 'skipped'
                        }">
                        {{ element.status }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="error">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Remarks</th>
                <td mat-cell *matCellDef="let element">
                    <span class="remark-text" [title]="element.error">{{ element.error || '—' }}</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns1;" [ngClass]="{
                    'row-success': row.status === 'success',
                    'row-skipped': row.status === 'skipped',
                    'row-failed':  row.status === 'failed'
                }">
            </tr>
        </table>

        <mat-paginator #paginator1 [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
    </div>

    <!-- ── ERROR ALERTS ── -->
    <div *ngIf="formatError" class="alert alert-danger">
        <p>The format of the imported data is incorrect. Please download the template and ensure the data matches the
            required format.</p>
        <button class="download-button" matTooltip="Click here to download CSV format" (click)="downloadTemplate()">
            Download Template
        </button>
    </div>

    <div *ngIf="employeeIdError" class="alert alert-danger">
        <p>
            The following Employee IDs contain invalid characters. Only letters, numbers, and underscores (_) are
            allowed:
            <strong>{{ invalidEmployeeIds.join(', ') }}</strong>
        </p>
    </div>

    <!-- ── PREVIEW TABLE ── -->
    <div *ngIf="!isImported">
        <div class="table-responsive" *ngIf="displayTable">
            <table *ngIf="!(formatError || employeeIdError)" mat-table [dataSource]="dataSource" matSort
                class="mat-elevation-z8">

                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <input type="checkbox" (change)="toggleSelectAll($event.target.checked)"
                            [checked]="selectedEmployees.length === importedData.length && importedData.length > 0">
                    </th>
                    <td mat-cell *matCellDef="let employee">
                        <input type="checkbox" (change)="onCheckboxChange(employee, $event.target.checked)"
                            [checked]="isSelected(employee)">
                    </td>
                </ng-container>

                <ng-container matColumnDef="employeeId">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Employee ID</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.employeeId }}</td>
                </ng-container>
                <ng-container matColumnDef="username">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Username</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.username }}</td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>First Name</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.firstName }}</td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Last Name</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.lastName }}</td>
                </ng-container>
                <ng-container matColumnDef="department">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Department</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.department }}</td>
                </ng-container>
                <ng-container matColumnDef="branch">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Branch</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.branch }}</td>
                </ng-container>
                <ng-container matColumnDef="payroll">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Payroll</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.payroll }}</td>
                </ng-container>
                <ng-container matColumnDef="payrollJob">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Payroll Job</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.payrollJob }}</td>
                </ng-container>
                <ng-container matColumnDef="startDate">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Start Date</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.startDate }}</td>
                </ng-container>
                <ng-container matColumnDef="endDate">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>End Date</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.endDate }}</td>
                </ng-container>
                <ng-container matColumnDef="sssNumber">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>SSS Number</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.sssNumber }}</td>
                </ng-container>
                <ng-container matColumnDef="philhealthNumber">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>PhilHealth</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.philhealthNumber }}</td>
                </ng-container>
                <ng-container matColumnDef="pagibigNumber">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Pag-IBIG</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.pagibigNumber }}</td>
                </ng-container>
                <ng-container matColumnDef="tinNumber">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>TIN</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.tinNumber }}</td>
                </ng-container>
                <ng-container matColumnDef="paymentRule">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Payment Rule</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.paymentRule }}</td>
                </ng-container>
                <ng-container matColumnDef="unpaidLunchBreak">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Lunch Break</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.unpaidLunchBreak }}</td>
                </ng-container>
                <ng-container matColumnDef="unpaidCoffeeBreak">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Coffee Break</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.unpaidCoffeeBreak }}</td>
                </ng-container>
                <ng-container matColumnDef="gracePeriod">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Grace Period</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.gracePeriod }}</td>
                </ng-container>
                <ng-container matColumnDef="firstTimeInBuffer">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>First Buffer</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.firstTimeInBuffer }}</td>
                </ng-container>
                <ng-container matColumnDef="lastTimeInBuffer">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Last Buffer</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.lastTimeInBuffer }}</td>
                </ng-container>
                <ng-container matColumnDef="maxOvertime">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Max OT</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.maxOvertime }}</td>
                </ng-container>
                <ng-container matColumnDef="regularHours">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Regular Hours</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.regularHours }}</td>
                </ng-container>
                <ng-container matColumnDef="totalVacation">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Total VL</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.totalVacation }}</td>
                </ng-container>
                <ng-container matColumnDef="totalSick">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Total SL</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.totalSick }}</td>
                </ng-container>
                <ng-container matColumnDef="availableVacation">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Avail. VL</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.availableVacation }}</td>
                </ng-container>
                <ng-container matColumnDef="availableSick">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Avail. SL</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.availableSick }}</td>
                </ng-container>
                <ng-container matColumnDef="streetAddress">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Street Address</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.streetAddress }}</td>
                </ng-container>
                <ng-container matColumnDef="country">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Country</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.country }}</td>
                </ng-container>
                <ng-container matColumnDef="region">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Region</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.region }}</td>
                </ng-container>
                <ng-container matColumnDef="province">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Province</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.province }}</td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>City</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.city }}</td>
                </ng-container>
                <ng-container matColumnDef="postal">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Postal</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.postal }}</td>
                </ng-container>
                <ng-container matColumnDef="phone">
                    <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Phone</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.phone }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator *ngIf="!formatError" [pageSizeOptions]="[5, 10]" showFirstLastButtons></mat-paginator>
    </div>
</div>

<!-- ── FOOTER ── -->
<div class="modal-footer large-modal" *ngIf="!isImported">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
    <button *ngIf="!isLoading; else loadingTemplate"
        [disabled]="formatError || employeeIdError || selectedEmployees.length === 0" type="button"
        class="btn btn-primary" (click)="saveSelectedEmployees()">
        Save ({{ selectedEmployees.length }})
    </button>
    <ng-template #loadingTemplate>
        <button type="button" class="btn btn-primary" disabled>
            Saving&hellip; <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </ng-template>
</div>

<div class="modal-footer large-modal" *ngIf="isImported">
    <span class="insertion-message me-auto">{{ insertionMessage }}</span>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Close</button>
</div>